import { h, Component, Event, EventEmitter, Prop } from '@stencil/core';
import { LngLatBoundsLike } from "maplibre-gl";

@Component({
  tag: 'tip-focus',
  styleUrl: 'focus.css'
})
export class Focus {
  @Prop() feature: any;
  @Prop() column: any;
  @Prop() value: string;

  @Event() glFlyTo: EventEmitter

  handleClick() {
    let geom = this.feature.geometry;
    if (geom.type === 'MultiLineString') {
      var bbox: LngLatBoundsLike = [geom.coordinates[0][0],
      geom.coordinates[0][
      geom.coordinates[0].length - 1
      ]];
    }
    if (geom.type === 'MultiPoint') {
      var bbox: LngLatBoundsLike = [
        geom.coordinates[0],
        geom.coordinates[0]
      ];
    }

    let glMap = document.querySelector('gl-map');
    glMap.map.fitBounds(bbox, {
      padding: 50,
      maxZoom: 15
    });
  }

  render() {
    if (this.value === undefined || this.value === null) {
      return
    }

    let id = this.value.replace(/[\,\s]/g, '');
    let columnProps = {
      'onClick': () => this.handleClick(),
      'id': id
    }
    if (this.feature.geometry.coordinates.length > 0) {
      return (<p {...columnProps}><a>{this.value}</a></p>)
    } else {
      return (<p>{this.value}</p>)
    }
  }
}
